var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-settings-send-after flex flex-col"},[_c('switch-input',{attrs:{"setup":{
      'func': _vm.sendAfterChange,
      'args': {
        'model': _vm.context,
        'key': 'sendAfter',
        'prefix': 'editor_options_',
        'tariffTags': _vm.tariffTags,
        disabled: _vm.disabled,
      }
    }}}),_c('transition',{attrs:{"name":"default-hide","mode":"out-in"}},[(_vm.isSettingVisible)?_c('period-simplifier',{attrs:{"disabled":!!_vm.tariffTags || _vm.disabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }